import { __decorate } from "tslib";
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import HelixElement from '../../shared/types/helix-element.js';
import { localized } from '@lit/localize';
import { componentStyles } from '../../shared/styles/component.styles.js';
import { badgeStyles } from './badge.styles.js';
let HlxBadge = class HlxBadge extends HelixElement {
    constructor() {
        super(...arguments);
        this.size = 'large';
        this.variant = 'brand';
        this.disabled = false;
    }
    render() {
        return html `
            <span
                part="base"
                class=${classMap({
            'hlx-badge': true,
            'hlx-badge-sm': this.size === 'small',
            'hlx-badge-md': this.size === 'medium',
            'hlx-badge-lg': this.size === 'large',
            'hlx-badge-brand': this.variant === 'brand',
            'hlx-badge-dark': this.variant === 'dark',
            'hlx-badge-success': this.variant === 'success',
            'hlx-badge-error': this.variant === 'error',
            'hlx-badge-warning': this.variant === 'warning',
            'hlx-badge-info': this.variant === 'info',
            'hlx-badge-disabled': this.disabled,
        })}
                role="status">
                ${this.size === 'large' ?
            html `
                        <slot></slot>
                    `
            : nothing}
            </span>
        `;
    }
};
HlxBadge.styles = [componentStyles, badgeStyles];
__decorate([
    property({ type: String, reflect: true })
], HlxBadge.prototype, "size", void 0);
__decorate([
    property({ type: String, reflect: true })
], HlxBadge.prototype, "variant", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], HlxBadge.prototype, "disabled", void 0);
HlxBadge = __decorate([
    customElement('hlx-badge'),
    localized()
], HlxBadge);
export { HlxBadge };
//# sourceMappingURL=badge.js.map